import { Box, Card, Grid, Typography } from "@mui/material";
import React from "react";
import { gradientColor } from "../../../contants";
import FlexButton from "../../../components/FlexButton";
import { useNavigate } from "react-router";

const dataArray = [
  {
    title: "Blog",
    description:
      "Check out our latest blog posts for insightful articles and updates.",
    btnTile: "Read More",
    href: "/resources/blog",
  },
  {
    title: "Announcement",
    description:
      "Stay informed with our company announcements and important updates.",
    btnTile: "Explore",
    href: "/resources/announcement",
  },
  {
    title: "News",
    description:
      "Get the latest news in the crypto world and stay ahead of the curve.",
    btnTile: "Discover",
    href: "/resources/news",
  },
];

export default function Resources() {
  const navigate = useNavigate();
  return (
    <Box className="mainContainer" sx={{ margin: "100px 0px" }}>
      <Box textAlign={"center"} mb={2}>
        <Typography variant="h2" sx={{ color: gradientColor }}>
          Resources
        </Typography>
      </Box>
      <Grid container spacing={3}>
        {dataArray &&
          dataArray.map((data, i) => {
            return (
              <Grid item lg={4} sm={4} md={4} xs={12} key={`resources${i}`}>
                <Card sx={{ padding: "20px" }} className="card">
                  <Box className="displayCenter" flexDirection={"column"}>
                    <Typography variant="h6">{data.title}</Typography>
                    <Typography variant="body2" mt={1} textAlign={"center"}>
                      {data.description}
                    </Typography>
                    <FlexButton
                      color="primary"
                      title={data.btnTile}
                      sx={{ padding: "4px", marginTop: "10px" }}
                      onClick={() => navigate(data.href)}
                    />
                  </Box>
                </Card>
              </Grid>
            );
          })}
      </Grid>
    </Box>
  );
}
